var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "21px",
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loadmore-icon 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loadmore-icon-2",
    fill: "#2C2853",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(10.552000, 10.541000) rotate(-90.000000) translate(-10.552000, -10.541000) translate(0.552000, 0.041000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001000, 0.035000)",
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.614,8.407 L10.676,0.465 C10.0486045,-0.161014764 9.03251476,-0.159895476 8.4065,0.4675 C7.78048524,1.09489548 7.78160452,2.11098524 8.409,2.737 L15.209,9.537 L8.409,16.337 C8.00386082,16.7421392 7.84563596,17.3326424 7.99392719,17.8860728 C8.14221842,18.4395032 8.57449678,18.8717816 9.12792719,19.0200728 C9.6813576,19.168364 10.2718608,19.0101392 10.677,18.605 L18.615,10.667 C19.237737,10.0422004 19.2372897,9.03124827 18.614,8.407 Z M9.07,7.927 L2.767,1.285 C2.47107639,0.966366493 2.05585411,0.78532138 1.621,0.78532138 C1.18614589,0.78532138 0.770923607,0.966366493 0.475,1.285 C-0.15798989,1.9655664 -0.15798989,3.0194336 0.475,3.7 L5.632,9.134 L0.475,14.565 C-0.15798989,15.2455664 -0.15798989,16.2994336 0.475,16.98 C0.770923607,17.2986335 1.18614589,17.4796786 1.621,17.4796786 C2.05585411,17.4796786 2.47107639,17.2986335 2.767,16.98 L9.067,10.338 C9.69836026,9.65878485 9.69966801,8.60778425 9.07,7.927 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrow);
export default __webpack_public_path__ + "static/media/upArrow.a9d984e762fa50785c3c1655f177605f.svg";
export { ForwardRef as ReactComponent };